(function(root){
  'use strict';
  const entrySkins=new Set(['quisquilloso','emocional','sin-congelador','salud-observada','calidad','multigato','proyecto','topper','primerizo','salud','foodie','ecological','scientific','hidratacion']);
  const landingSkins=new Set(['quisquilloso','emocional','sin-congelador','calidad','multigato','hidratacion','garantia']);
  const normalize=value=>String(value||'').trim().toLowerCase().replace(/^sincongelador$/,'sin-congelador');
  function resolve(url,remembered=''){
    const u=new URL(url,'https://chefmiau.com');
    const p=u.searchParams;
    let raw=normalize(p.get('angle')||p.get('cm_angle')||p.get('utm_content')||'');
    let source=p.get('angle')?'angle':p.get('cm_angle')?'cm_angle':p.get('utm_content')?'utm_content':'default';
    if(!raw&&u.pathname.replace(/\/+$/,'').toLowerCase()==='/pages/gatos-exigentes'){raw='quisquilloso';source='path';}
    const saved=String(remembered||'').trim().toLowerCase();
    const entrySkin=raw==='default'?'default':entrySkins.has(raw)?raw:raw?'desconocido':entrySkins.has(saved)?saved:'default';
    if(!raw&&entrySkins.has(saved))source='session';
    let landingAngle=landingSkins.has(entrySkin)?entrySkin:'default';
    // Closed presentation mapping, without introducing a new backend entry_skin enum.
    if(raw==='garantia'||raw==='b06_garantia_v3')landingAngle='garantia';
    return {entrySkin,landingAngle,source};
  }
  // Presentation memory is separate from the historical entry_skin used by the backend.
  // Only the review bootstrap supplies isolated Storage; never read/write production Storage here.
  const presentationKey='cm_growth_landing_angle_v1';
  function resolveReview(url,remembered=''){
    const resolved=resolve(url,remembered);
    if(root.CMReview?.isolated!==true)return resolved;
    try{
      const u=new URL(url,'https://chefmiau.com');
      const explicit=['angle','cm_angle','utm_content'].some(key=>u.searchParams.has(key));
      const specialPath=u.pathname.replace(/\/+$/,'').toLowerCase()==='/pages/gatos-exigentes';
      const saved=root.sessionStorage.getItem(presentationKey);
      const validSaved=saved==='default'||landingSkins.has(saved);
      if(!explicit&&!specialPath&&validSaved){
        return {...resolved,landingAngle:saved,landingSource:'review-session'};
      }
      root.sessionStorage.setItem(presentationKey,resolved.landingAngle);
    }catch{/* Blocked storage must not interrupt the quiz or change URL precedence. */}
    return resolved;
  }
  root.CMGrowthRouting=Object.freeze({resolve,resolveReview});
})(typeof window==='undefined'?globalThis:window);
